var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('v-select',{attrs:{"items":_vm.supplierTypesArray,"item-text":"name","item-value":"id","label":_vm.label},on:{"change":_vm.onChange},model:{value:(_vm.selectedSupplierType),callback:function ($$v) {_vm.selectedSupplierType=$$v},expression:"selectedSupplierType"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-587239fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/SupplierType.vue
// module id = null
// module chunks = 